import React from 'react';
import { Link } from 'react-router-dom'; // Added for client-side routing on internal links
const Services = () => {
  return (
    <section className="services">
      <div className="container">
        <h2>Our Services</h2>
        <h2>WYSIWYG</h2>
        <p>Comprehensive financial services powered by blockchain technology and $ENS Domains on Ethereum - Coming Soon.</p>
        <div className="service-cards">
          <Link to="/web3pay" className="service-card" style={{ textDecoration: 'none', color: 'inherit', boxShadow: '0 0 20px gold', transition: 'box-shadow 0.3s ease' }}
            onMouseEnter={(e) => e.currentTarget.style.boxShadow = '0 0 40px gold'}
            onMouseLeave={(e) => e.currentTarget.style.boxShadow = '0 0 20px gold'}
          >
            <i className="fas fa-exchange-alt"></i>
            <h3>Payments</h3>
            <p className="eth-label" style={{ color: 'var(--gold)' }}>Web3Pay.eth</p>
            <p>Daily-use stablecoin wallet for balances and transfers. QR code-based payments for goods (P2P or in-store).</p>
          </Link>
          <Link to="/web3cash" className="service-card" style={{ textDecoration: 'none', color: 'inherit', boxShadow: '0 0 20px gold', transition: 'box-shadow 0.3s ease' }}
            onMouseEnter={(e) => e.currentTarget.style.boxShadow = '0 0 40px gold'}
            onMouseLeave={(e) => e.currentTarget.style.boxShadow = '0 0 20px gold'}
          >
            <i className="fas fa-money-check"></i>
            <h3>Cash</h3>
            <p className="eth-label" style={{ color: 'var(--gold)' }}>Web3Cash.eth</p>
            <p>ENS-gated platform where decentralized lending and savings empower your financial future.</p>
          </Link>
          <Link to="/web3fx" className="service-card" style={{ textDecoration: 'none', color: 'inherit', boxShadow: '0 0 20px gold', transition: 'box-shadow 0.3s ease' }}
            onMouseEnter={(e) => e.currentTarget.style.boxShadow = '0 0 40px gold'}
            onMouseLeave={(e) => e.currentTarget.style.boxShadow = '0 0 20px gold'}
          >
            <i className="fas fa-chart-line"></i>
            <h3>Forex</h3>
            <p className="eth-label" style={{ color: 'var(--gold)' }}>Web3FX.eth</p>
            <p>Currency Exchange, Secure swaps with competitive fees, Swap Stablecoins World Wide, 24/7 Markets.</p>
          </Link>
          <Link to="/web3broker" className="service-card" style={{ textDecoration: 'none', color: 'inherit', boxShadow: '0 0 20px gold', transition: 'box-shadow 0.3s ease' }}
            onMouseEnter={(e) => e.currentTarget.style.boxShadow = '0 0 40px gold'}
            onMouseLeave={(e) => e.currentTarget.style.boxShadow = '0 0 20px gold'}
          >
            <i className="fas fa-briefcase"></i>
            <h3>Broker</h3>
            <p className="eth-label" style={{ color: 'var(--gold)' }}>Web3Broker.eth</p>
            <p>Advanced Tokenized Stock Trading Platform, Whith Grok xAI as your guide, World Wide, 24/7 Markets.</p>
          </Link>
          <Link to="/web3markets" className="service-card" style={{ textDecoration: 'none', color: 'inherit', boxShadow: '0 0 20px gold', transition: 'box-shadow 0.3s ease' }}
            onMouseEnter={(e) => e.currentTarget.style.boxShadow = '0 0 40px gold'}
            onMouseLeave={(e) => e.currentTarget.style.boxShadow = '0 0 20px gold'}
          >
            <i className="fas fa-shopping-cart"></i>
            <h3>Markets</h3>
            <p className="eth-label" style={{ color: 'var(--gold)' }}>Web3Markets.eth</p>
            <p>RWA Marketplace, Tokenized Real World Assets, World Wide, 24/7 Markets.</p>
          </Link>

          {/* REPLACED: MoneyTalks card with BsWallet card */}
          <a href="https://banksystem.co/banksystem/" className="service-card" style={{ textDecoration: 'none', color: 'inherit', boxShadow: '0 0 20px gold', transition: 'box-shadow 0.3s ease' }}
            onMouseEnter={(e) => e.currentTarget.style.boxShadow = '0 0 40px gold'}
            onMouseLeave={(e) => e.currentTarget.style.boxShadow = '0 0 20px gold'}
          >
            <i className="fas fa-wallet"></i> {/* Updated icon for wallet */}
            <h3>BankSystem Wallet</h3>
            <p className="eth-label" style={{ color: 'var(--gold)' }}>BankSystem.eth</p>
            <p>Experience the future of Self-Custody with our Military-grade secure wallet technology. Seamless integration with all BankSystem services.</p>
          </a>

          <Link to="/moneyTalks" className="service-card" style={{ textDecoration: 'none', color: 'inherit', boxShadow: '0 0 20px gold', transition: 'box-shadow 0.3s ease' }}
            onMouseEnter={(e) => e.currentTarget.style.boxShadow = '0 0 40px gold'}
            onMouseLeave={(e) => e.currentTarget.style.boxShadow = '0 0 20px gold'}
          >
            <i className="fas fa-id-card"></i>
            <h3>Identity</h3>
            <p className="eth-label" style={{ color: 'var(--gold)' }}>xbsys.eth</p>
            <p>BankSystem operates its own ENS minting contract, providing unparalleled security and integration. Register Your Access .xbsys.eth Domain $50, Programmable ENS DOMAIN.</p>
          </Link>
          <Link to="/dbank" className="service-card" style={{ textDecoration: 'none', color: 'inherit', boxShadow: '0 0 20px gold', transition: 'box-shadow 0.3s ease' }}
            onMouseEnter={(e) => e.currentTarget.style.boxShadow = '0 0 40px gold'}
            onMouseLeave={(e) => e.currentTarget.style.boxShadow = '0 0 20px gold'}
          >
            <i className="fas fa-coins"></i>  {/* Added icon for $DBANK */}
            <h3>$DBANK Coin</h3>
            <p className="eth-label" style={{ color: 'var(--gold)' }}>BankSystem.eth</p>
            <p>$DBANK Shares, a new IPO launching on BankSystem.eth, feature bank ownership with 1B total shares: 100M for sale at an offering price of $0.45 per share, and 900M founder-held forever.</p>
          </Link>
        </div>

        {/* NEW: Rectangular MoneyTalks card below the main grid */}
        <div style={{
          marginTop: '40px',
          display: 'flex',
          justifyContent: 'center'
        }}>
          <Link
            to="/moneytalks"
            className="service-card"
            style={{
              textDecoration: 'none',
              color: 'inherit',
              boxShadow: '0 0 20px gold',
              transition: 'box-shadow 0.3s ease',
              width: '100%',
              maxWidth: '800px',
              display: 'flex',
              flexDirection: 'row',
              alignItems: 'center',
              padding: '25px'
            }}
            onMouseEnter={(e) => e.currentTarget.style.boxShadow = '0 0 40px gold'}
            onMouseLeave={(e) => e.currentTarget.style.boxShadow = '0 0 20px gold'}
          >
            <div style={{
              marginRight: '25px',
              fontSize: '48px',
              color: 'var(--gold)'
            }}>
              <i className="fas fa-users"></i>
            </div>
            <div style={{ flex: 1 }}>
              <h3 style={{ color: 'var(--gold)', marginBottom: '15px', fontSize: '24px' }}>
                MoneyTalks Community
              </h3>
              <p className="eth-label" style={{ color: 'var(--gold)', marginBottom: '15px' }}>
                Finance Forum & Discussion
              </p>
              <p style={{ lineHeight: '1.6', fontSize: '16px', margin: 0 }}>
                Exchange views on finance, DeFi, RWAs. ENS required for posting (e.g., john.xbsys.eth).
                Join our vibrant community to discuss strategies, share insights, and build knowledge together
                in our transparent financial community powered by Drupal integration.
              </p>
            </div>
          </Link>
        </div>
      </div>
    </section>
  );
};
export default Services;
